export const BLE_CONFIG = {
  serviceUUID: '4fafc201-1fb5-459e-8fcc-c5c9c331914b',
  characteristicUUID: 'beb5483e-36e1-4688-b7f5-ea07361b26a8',
  commandCharacteristicUUID: 'beb5483e-36e1-4688-b7f5-ea07361b26a9',
};

export const DEFAULT_SETTINGS = {
  maxDataPoints: 100,
  dataProcessing: {
    smoothing: false,
    smoothingFactor: 0.1,
    scaling: 1,
    offset: 0
  }
};
